
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/[webinar]",
      function () {
        return require("private-next-pages/webinars/[webinar].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/[webinar]"])
      });
    }
  